var E = Object.defineProperty, n = Object.defineProperties;
var I = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var N = Object.prototype.hasOwnProperty, _ = Object.prototype.propertyIsEnumerable;
var t = (m, l, x) => l in m ? E(m, l, { enumerable: !0, configurable: !0, writable: !0, value: x }) : m[l] = x, o = (m, l) => {
  for (var x in l || (l = {}))
    N.call(l, x) && t(m, x, l[x]);
  if (s)
    for (var x of s(l))
      _.call(l, x) && t(m, x, l[x]);
  return m;
}, O = (m, l) => n(m, I(l));
const c = {
  sm: "sm",
  md: "md",
  lg: "lg"
}, M = O(o({}, c), {
  xl: "xl",
  xxl: "xxl"
}), a = {
  initial: "90vh",
  full: "100vh"
}, i = {
  sm: "sm",
  m: "m",
  lg: "lg",
  xl: "xl",
  auto: "auto"
};
export {
  c as COMPONENT_SIZE,
  M as ICON_COMPONENT_SIZE,
  a as MODAL_HEIGHT,
  i as MODAL_SIZE
};
//# sourceMappingURL=sizes.es.js.map
